// Brand slots for the landing page: the logo and the per-format icons come from the v3 brand kit (web/src/brand),
// behind these small components so the landing has one place to change them. The logo is only ever drawn through
// the kit's <Logo> (the director's chair and its wordmark). The kit's colours come from
// tokens.css when the app root imports it; the format icons get their group's gel directly, so they're right
// either way.
import { BRAND, FORMAT_BRAND, FormatBadge, GELS, Logo, FormatIcon as BrandFormatIcon, type FormatId } from "../brand";

export { BRAND };

/** The format's chip (icon + short name in its gel), or nothing for a format the brand doesn't know yet. */
export function FormatChip({ id }: { id: string }) {
  return isFormat(id) ? <FormatBadge id={id} variant="chip" /> : null;
}


/** The horizontal lockup, linking home; phones get the chair alone (docs/brand/README.md). `height` is the chair's. */
export function LandingLogo({ height = 44 }: { height?: number }) {
  return (
    <a className="lp-wordmark" href="/" aria-label="CAO Studio home">
      <Logo height={height} decorative className="lp-logo-wide" />
      <Logo layout="mark" height={Math.round(height * 0.95)} decorative className="lp-logo-narrow" />
    </a>
  );
}

const isFormat = (id: string): id is FormatId => Object.prototype.hasOwnProperty.call(FORMAT_BRAND, id);

/** The format's brand icon in its group's gel (nothing for a format the brand doesn't know yet). */
export function FormatIcon({ id, size = 22 }: { id: string; size?: number }) {
  if (!isFormat(id)) return null;
  return <BrandFormatIcon id={id} size={size} color={GELS[FORMAT_BRAND[id].group].dark} className="lp-fc-icon" />;
}

/** A group's gel colour (the group heading on the showcase), or null for a group the brand doesn't know. */
export function gelOf(group: string): string | null {
  return (GELS as Record<string, { dark: string }>)[group]?.dark ?? null;
}
